import React, { useEffect, useState } from 'react';
import './ProjectTask.css';
import ViewTaskProducts from './ViewTaskProducts/ViewTaskProducts';
import ProjectTaskAPIs from '../../../../../../../MasonyFixingsAPIs/ProjectTaskAPIs/ProjectTaskAPIs';
import { AiFillEdit } from 'react-icons/ai';
import DropDown from '../../../../../../DropDown/DropDown';
import { Form, Row, Col, Alert, Collapse } from 'react-bootstrap';
import ProjectAPIs from '../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs';
import { useNavigate, useParams } from 'react-router-dom';
import { MdCancel, MdDelete, MdEdit } from 'react-icons/md';
import { GiScrew } from "react-icons/gi";
import { FaSave } from 'react-icons/fa';
import {format} from 'date-fns'
import ApiResponseHandler from '../../../../../../../MasonyFixingsAPIs/ApiResponseHandler';
import LookupAPIs from '../../../../../../../MasonyFixingsAPIs/LookupAPIs/LookupAPIs';
import { useToast } from '../../../../../../../Contexts/ToastContext';

export default function ProjectTask({projectTaskID, getProjectTasks}){

    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();
    
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [showProducts, setShowProducts] = useState(false);
    const [incorrectDates, setIncorrectDates] = useState(false);

    const [users, setUsers] = useState([]);
    const [projectTaskInfo, setProjectTaskInfo] = useState({});
    const [taskID, setTaskID] = useState('');
    const [companyID, setCompanyID] = useState('');
    const [taskTypeID, setTaskTypeID] = useState('');
    const [approxVal, setApproxVal] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [userID, setUserID] = useState('');

    // Use taskID to make an API call to get the ProjectTask

    const getProjectTaskInfo = (projectTaskID) => {

        ProjectTaskAPIs.GetProjectTask(projectTaskID)
        .then((response) => {
            console.log(response.data)
            if(response.status === 200){
                setProjectTaskInfo(response.data);
                setTaskID(response.data.task?.id === null ? '' : response.data.task?.id);
                setCompanyID(response.data.company?.id === null ? '' : response.data.company?.id);
                setTaskTypeID(response.data.task_type === null ? '' : response.data.task_type.id);
                setApproxVal(response.data.approx_val === null ? '' : response.data.approx_val);
                setStartDate(response.data.start_date === null ? '' : format(new Date(response.data.start_date), 'yyyy-MM-dd'));
                setEndDate(response.data.end_date === null ? '' : format(new Date(response.data.end_date), 'yyyy-MM-dd'));
                setUserID(response.data.user_id === null ?  '' : response.data.user_id);
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    setEditing(false);
                    window.alert(err.response.data.message)
                }
            }
        })
    } 

    const editProjectTask = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSending(true);
        setIncorrectDates(false);
        const putJSON = {
            task_id: taskID,
            company_id: companyID === '' ? null : companyID,
            task_type_id: taskTypeID,
            approx_val: approxVal === '' ? null : approxVal,
            start_date: startDate === '' ? null : startDate,
            end_date: endDate === '' ? null : endDate,
            user_id: userID === '' ? null : userID
        }

        if(startDate && endDate){
            if((format(new Date(startDate), 'T')) > (format(new Date(endDate), 'T'))){
                setIncorrectDates(true);
                setSending(false);
                return;
            }
        }
        
        ProjectAPIs.PutProjectTask(params.ProjectID, projectTaskID, putJSON)
        .then((response) => {
            if(response.status === 200){
                getProjectTasks(params.ProjectID)
                setEditing(false);
                setSending(false);
                getProjectTaskInfo(projectTaskID);
                addToast({ message: "Task updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    handleCancel();
                    window.alert(err.response.data.message)
                }
            }
        })
        
    }

    const deleteProjectTask = () => {
        setSending(true);
        ProjectTaskAPIs.DeleteProjectTask(projectTaskID)
        .then((response) => {
            if(response.status === 200){
                getProjectTasks(params.ProjectID);
                setEditing(false);
                setSending(false);
                getProjectTaskInfo(projectTaskID);
                addToast({ message: "Task deleted successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })
    }

    const handledDelete = () => {

        if(window.confirm('Are you sure you want to delete this task? You will lose all associated products and potential sales figures.')){
            deleteProjectTask();
        }
    }

    const handleChangeTask = (e) => {
        setTaskID(e.target.value);
        setTaskTypeID('');
    }

    const handleCancel = () => {
        setTaskID(projectTaskInfo.task?.id ?? '');
        setCompanyID(projectTaskInfo.company?.id ?? '');
        setTaskTypeID(projectTaskInfo.task_type?.id ?? '');
        setApproxVal(projectTaskInfo.approx_val ?? '');
        setStartDate(projectTaskInfo.start_date ? format(new Date(projectTaskInfo.start_date), 'yyyy-MM-dd') : '');
        setEndDate(projectTaskInfo.end_date ? format(new Date(projectTaskInfo.end_date), 'yyyy-MM-dd') : '');
        setUserID(projectTaskInfo.user_id ?? '');
        setIncorrectDates(false);
        setEditing(false);
    }

    const getUsers = () => {
        LookupAPIs.GetUsers()
        .then((response) => {
            setUsers(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })

    }

    useEffect(()  => {
        getProjectTaskInfo(projectTaskID);
    }, [projectTaskID])

    useEffect(() => {
        getUsers();
    }, [])

    if(loading){
        return(
            <div className='project-task-container'>Loading...</div>
        )
    }


    else{
        return(
            <div className="view-contractor-employee-container mt-2">
            <div className='project-section'>
                <Form onSubmit={editProjectTask}>
                <div className='project-section-header'>
                    <h4 className="section-title">{projectTaskInfo.task.name}</h4>
                    <div className="project-header-actions">
                        {editing ? (
                            <>
                                <button size="sm" type='submit' disabled={sending} className="save-btn">Save</button>
                                <button size="sm" type='button' disabled={sending} className="cancel-btn" onClick={() => handleCancel()} >Cancel</button>
                            </>
                        ) : (
                            <>
                                <button size="sm" type='button'  disabled={sending} className="edit-btn" onClick={() => setEditing(true)}><MdEdit /> Edit</button>
                                <button size="sm" type='button' disabled={sending} className="projects-delete-btn" onClick={() => handledDelete()} ><MdDelete /></button>
                            </>
                        )}
                    </div>
                </div>
                
                <div className='project-section-body'>

                    <div className='project-section-body-column'>

                        {editing ? 
                        <div className="project-section-body-item m-1">
                            <span className="label">Task:</span>
                            <DropDown.Task disabled={sending || !editing} size='sm' className='editable-field' required value={taskID} onChange={handleChangeTask} />
                        </div>
                        :
                        <div className="project-section-body-item m-1">
                            <span className="label">Task:</span>
                            {projectTaskInfo.task?.name ?? ''}
                        </div>
                        }

                        {editing ? 
                            <div className="project-section-body-item m-1">
                                <span className="label">Type:</span>
                                <DropDown.TaskType 
                                    size='sm'
                                    taskID={taskID} 
                                    disabled={sending || !editing}
                                    value={taskTypeID}
                                    className='editable-field'
                                    onChange={(e) => setTaskTypeID(e.target.value)}
                                    required
                                />   
                            </div>
                        :
                            <div className="project-section-body-item m-1">
                                <span className="label">Type:</span>
                                {projectTaskInfo.task_type?.name ?? ''}
                            </div>
                        }
                    </div>

                    <div className='project-section-body-column'>

                        {editing ?  
                        <div className="project-section-body-item m-1">
                            <span className="label">Sales Rep:</span>
                            <DropDown.Users 
                                size='sm'
                                value={userID} 
                                onChange={(e) => setUserID(e.target.value)}
                                className='editable-field'
                                disabled={!editing || sending}
                            />
                        </div>
                        :
                        <div className="project-section-body-item m-1">
                            <span className="label">Sales Rep:</span>
                            {users.find((u) => u.id === projectTaskInfo.user_id)?.first_name ?? 'Unassigned'} {users.find((u) => u.id === projectTaskInfo.user_id)?.last_name ?? ''}
                        </div>
                        }
                        {editing ? 
                        <div className="project-section-body-item m-1">
                            <span className="label">Start Date:</span>
                            <Form.Control 
                                    size='sm'
                                    type='date' 
                                    value={startDate} 
                                    onChange={(e) => setStartDate(e.target.value)}
                                    // required 
                                    className='editable-field'
                                    disabled={!editing || sending}
                                    isInvalid={incorrectDates}
                                />
                        </div>
                        :
                        <div className="project-section-body-item m-1">
                            <span className="label">Start Date:</span>
                            {projectTaskInfo.start_date ? format(new Date(projectTaskInfo.start_date), 'dd / LLL / yyyy') : 'Not set'}
                        </div>
                        }
                        {editing ?
                        <div className="project-section-body-item m-1">
                            <span className="label">End Date:</span>
                            <Form.Control 
                                size='sm'
                                type='date' 
                                value={endDate} 
                                onChange={(e) => setEndDate(e.target.value)}
                                // required 
                                className='editable-field'
                                disabled={!editing || sending}
                                isInvalid={incorrectDates}
                            />
                        </div>

                        :
                        <div className="project-section-body-item m-1">
                            <span className="label">End Date:</span>
                            {projectTaskInfo.end_date ? format(new Date(projectTaskInfo.end_date), 'dd / LLL / yyyy') : 'Not set'}
                        </div>
                        }
                        
                    </div>

                    <div className='project-section-body-column'>

                        {editing ? 
                        
                        <div className="project-section-body-item m-1">
                            <span className="label">Company:</span>
                            <DropDown.AllCompanies disabled={!editing || sending} className='editable-field' size='sm' value={companyID} onChange={(e) => setCompanyID(e.target.value)} />
                        </div>
                        :
                        <div className="project-section-body-item m-1">
                            <span className="label">Company:</span>
                            {projectTaskInfo.company?.name ?? 'Unassigned'}
                        </div>}

                        {editing ? 
                        <div className="project-section-body-item m-1">
                            <span className="label">Approx Val:</span>
                            <Form.Control
                                type='number'
                                value={approxVal}
                                onChange={(e) => setApproxVal(e.target.value)}
                                size='sm'
                                // required
                                className='editable-field'
                                disabled={!editing || sending}
                            />
                        </div>
                        :
                        <div className="project-section-body-item m-1">
                            <span className="label">Approx Val:</span>
                            {projectTaskInfo?.approx_val ?? 'Not set'}
                        </div>}

                        <div className="project-section-body-item m-1">
                            <div className="project-header-actions">
                                <button size="sm" type='button' disabled={sending} className="cancel-btn" onClick={() => setShowProducts(!showProducts)}><GiScrew/> Products</button>
                            </div>
                        </div>
                        
                    </div>

                    

                </div>

                
                {/* <div className='project-task-body'>
                    
                    <div>
                        <Form.Group as={Row}>
                            <Form.Label column sm={3}><strong>Task:</strong></Form.Label>
                            <Col sm={9}>
                                <DropDown.Task disabled={!editing} size='sm' required value={taskID} onChange={handleChangeTask} />
                            </Col>
                        </Form.Group>
                        <Row>
                            <Col>
                                
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}><strong>Task Type:</strong></Form.Label>
                                    <Col>
                                        <DropDown.TaskType 
                                            size='sm'
                                            taskID={taskID} 
                                            disabled={!editing}
                                            value={taskTypeID}
                                            onChange={(e) => setTaskTypeID(e.target.value)}
                                            required
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}><strong>Approx Val:</strong></Form.Label>
                                    <Col>
                                        <Form.Control
                                            type='number'
                                            value={approxVal}
                                            onChange={(e) => setApproxVal(e.target.value)}
                                            size='sm'
                                            required
                                            disabled={!editing}
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}><strong>Rep:</strong></Form.Label>
                                    <Col>
                                        <DropDown.Users 
                                            size='sm'
                                            value={userID} 
                                            onChange={(e) => setUserID(e.target.value)}
                                            required
                                            disabled={!editing}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}><strong>Company:</strong></Form.Label>
                                    <Col>
                                        <DropDown.AllCompanies disabled={!editing} size='sm' required value={companyID} onChange={(e) => setCompanyID(e.target.value)} />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}><strong>Start Date:</strong></Form.Label>
                                    <Col>
                                        <Form.Control 
                                            size='sm'
                                            type='date' 
                                            value={startDate} 
                                            onChange={(e) => setStartDate(e.target.value)}
                                            required 
                                            disabled={!editing}
                                            isInvalid={incorrectDates}
                                        />
                                        </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Form.Label column sm={4}><strong>End Date:</strong></Form.Label>
                                    <Col>
                                        <Form.Control 
                                            size='sm'
                                            type='date' 
                                            value={endDate} 
                                            onChange={(e) => setEndDate(e.target.value)}
                                            required 
                                            disabled={!editing}
                                            isInvalid={incorrectDates}
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>

                    <div align='end'>
                        <div>
                              
                            {editing ? 
                            <div>
                                <button disabled={sending} type={'submit'}><FaSave/></button> 
                                <button disabled={sending} type='button' onClick={() => handleCancel()}><MdCancel/></button> 
                            </div>   
                            :
                            <div>
                                <button disabled={sending} type={'button'} onClick={() => handledDelete()}><MdDelete/></button> 
                                <button type='button' onClick={() => setEditing(true)}><AiFillEdit/></button>
                            </div>
                            }
                        </div>
                        
                        <div><button type='button' onClick={() => setShowProducts(!showProducts)}><GiScrew style={{rotate: '90deg'}}/></button></div>
                    </div>
                    
                </div> */}
                </Form>

                {/* {incorrectDates && <Alert variant='danger'>End Date cannot be before Start Date</Alert>} */}
                
                
                

                {/* {showProducts &&
                    <ViewTaskProducts projectTaskID={projectTaskID} />
                } */}

            </div>
            {incorrectDates && <Alert variant='danger'>End Date cannot be before Start Date</Alert>}
            <Collapse in={showProducts}>
                <div>
                <ViewTaskProducts projectTaskID={projectTaskID} />
                </div>
            </Collapse>
            </div>
        )
    }
}
